import { z } from "zod";

// Two independent dismissals — the New Project flow letter and the dashboard popup — each campaign-keyed; bumping the campaign re-arms everyone.
const STORAGE_KEY_BY_SURFACE = {
  "create-flow": "replo.agentLaunch.dismissal.create-flow",
  popup: "replo.agentLaunch.dismissal.popup",
} as const;

type AgentLaunchSurface = keyof typeof STORAGE_KEY_BY_SURFACE;

const AGENT_LAUNCH_CAMPAIGN = "2026-09";

const launchDismissalSchema = z.object({
  dismissedAt: z.string(),
  campaign: z.string(),
});

export function isAgentLaunchDismissed(surface: AgentLaunchSurface): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_BY_SURFACE[surface]);
    if (!raw) {
      return false;
    }
    const parsed = launchDismissalSchema.safeParse(JSON.parse(raw));
    return parsed.success && parsed.data.campaign === AGENT_LAUNCH_CAMPAIGN;
  } catch {
    return false;
  }
}

export function recordAgentLaunchDismissal(surface: AgentLaunchSurface) {
  try {
    localStorage.setItem(
      STORAGE_KEY_BY_SURFACE[surface],
      JSON.stringify({
        dismissedAt: new Date().toISOString(),
        campaign: AGENT_LAUNCH_CAMPAIGN,
      }),
    );
  } catch {
    // Storage can throw (private mode / quota); the letter reappearing later is acceptable.
  }
}

export function clearAgentLaunchDismissal(surface: AgentLaunchSurface) {
  try {
    localStorage.removeItem(STORAGE_KEY_BY_SURFACE[surface]);
  } catch {
    // Ignore: a failed clear only means the letter stays dismissed.
  }
}
